import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CognitoVerificationAttributes } from '@core/enums';
import { Observable } from 'rxjs';

export interface IVerifyAttribute {
  success: boolean;
  error: boolean | string;
  code?: string;
}

export interface ISendVerificationCode {
  accessToken: string;
  error?: boolean | string;
  code?: string;
}

export interface ICheckAttributeVerification {
  verified: boolean;
  accessToken: string;
  error?: boolean | string;
  code?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountVerificationService {
  constructor(private http: HttpClient) {}

  /**
   *
   * @param userName Cognito account username
   * @param password Cognito account password
   * @param attribute Congito verification attribute
   * @param accessToken Congito verification accessToken. Not a mandatory field. If sent, myhivve-api skips the authentication step.
   * @description `Sends verification code to the cognito user contact attributes (email, phone).
   * If access Token is sent will skip authentication action`.
   */
  sendVerification(
    userName: string,
    password: string,
    attribute: string,
    accessToken?: string
  ): Observable<ISendVerificationCode> {
    return this.http.post<ISendVerificationCode>('/account/verification/send', {
      userName,
      password,
      attribute,
      accessToken
    });
  }

  /**
   *
   * @param email Cognito account email
   * @param attribute Cognito verification attribute
   * @param accessToken Congito verification accessToken.
   * @description `Resends verification code to the cognito user contact attributes ("email", "phone_number").`
   */
  resendVerification(
    attribute: CognitoVerificationAttributes,
    accessToken?: string
  ): Observable<ISendVerificationCode> {
    return this.http.post<ISendVerificationCode>('/account/verification/send', {
      attribute,
      accessToken,
      resendCode: true
    });
  }

  /*
   *
   * @description: `Verify user contact attributes`
   */
  confirmVerification(
    accessToken: string,
    verificationCode: string,
    attribute: string
  ): Observable<IVerifyAttribute> {
    return this.http.post<IVerifyAttribute>('/account/verification/confirm', {
      accessToken,
      verificationCode,
      attribute
    });
  }

  /**
   *
   * @param email string
   * @param password string
   * @param attribute string
   * @description `Check if user contact attributes are verified`
   */
  getVerificationStatus(
    email: string,
    password: string,
    attribute: CognitoVerificationAttributes
  ): Observable<ICheckAttributeVerification> {
    return this.http.post<ICheckAttributeVerification>('/account/verification/status', {
      email,
      password,
      attribute
    });
  }
}
